import { useTranslation } from 'react-i18next';

import { Card, CardContent, CardFooter } from '@app/shared/ui/atoms/Common';
import { diamondIcon } from '@app/assets';

interface SettlementMarketItemProps {
  name: string;
  icon: string;
  tonAmount: number;
  onSettlementCLick: (value: string) => void;
}

export function SettlementMarketItem({
  name,
  icon,
  tonAmount,
  onSettlementCLick,
}: SettlementMarketItemProps) {
  const { t } = useTranslation();

  return (
    <Card
      className="flex min-h-[150px] flex-col justify-between border-none bg-[#eff4f6] p-[10px] cursor-pointer"
      onClick={() => {
        onSettlementCLick(tonAmount.toString());
      }}
    >
      <CardContent className="p-0">
        <img src={icon} alt={`${name} icon`} />
      </CardContent>
      <CardFooter className="flex items-center text-secondary-foreground justify-between rounded-lg bg-blue-light p-[3px_5px] text-xs">
        <span>{t(`settlements.titles.${name}`)}</span>
        <div className="flex items-center gap-1">
          <span className="text-accent">{tonAmount}</span>
          <img src={diamondIcon} width={15} alt="diamond icon" />
        </div>
      </CardFooter>
    </Card>
  );
}
